import { select } from '@ps/web-core-store';
import type { ResolvedIntlConfig } from 'react-intl';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';

export interface IntlProviderProps {
  messages?: ResolvedIntlConfig['messages'];
}

const IntlProvider: React.FC<React.PropsWithChildren<IntlProviderProps>> = ({
  children,
  messages
}) => {
  const intlLocale = useSelector(select.locale.getIntlLocale);
  const timeZone = useSelector(select.timeZone.getTimeZoneName);

  return (
    <ReactIntlProvider
      locale={intlLocale}
      defaultLocale={intlLocale}
      messages={messages}
      timeZone={timeZone}
    >
      {children}
    </ReactIntlProvider>
  );
};

export default IntlProvider;
